module.exports = __webpack_public_path__ + "img/error.263bd71f.svg";